import {
  Baby,
  Buildings,
  Cube,
  Drop,
  ForkKnife,
  Package,
  PaintBucket,
  ShoppingBag,
  Sparkle,
  SprayBottle,
  Stack,
  Tag,
  Wine,
} from '@phosphor-icons/react';

const FALLBACK = [Package, Cube, Tag, ShoppingBag, Stack, Drop];

/**
 * Alt kategori anahtarına göre tutarlı bir Phosphor ikon bileşeni döner (görsel yerine).
 */
export function getSubcategoryIconComponent(key) {
  const k = (key || '').toLowerCase();

  if (/juice|drink|water|nectar|coffee|energy|fruit\s*drink|organic\s*juice|mineral/.test(k)) {
    return Wine;
  }
  if (
    /pasta|wheat|flour|bulgur|semolina|noodle|salt|tomato|pickle|grape|dried|jam|chocolate|candy|biscuit|chip|ice\s*coffee|roasted|stuffed|oil|leaf/.test(
      k
    )
  ) {
    return ForkKnife;
  }
  if (/marble|tile|cement|ceramic|brick/.test(k)) {
    return Buildings;
  }
  if (/paint|paintbrush|palette/.test(k)) {
    return PaintBucket;
  }
  if (/surface|glass|drain|rust|lime|dish|laundry|soap|cleaner|detergent|softener|opener|brightener|liquid/.test(k)) {
    return SprayBottle;
  }
  if (/diaper|toilet|paper|wipe|napkin|sanitary|tissue|handkerchief|facial/.test(k)) {
    return Baby;
  }
  if (/care|personal|sparkle|beauty/.test(k)) {
    return Sparkle;
  }

  let h = 0;
  for (let i = 0; i < k.length; i += 1) {
    h = (h + k.charCodeAt(i) * (i + 3)) % 997;
  }
  return FALLBACK[h % FALLBACK.length];
}
